/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Rolodex_FirmDetail_FirmEmployeeFullPartsFragment = {
  readonly __typename?: 'FirmEmployeeFull';
  readonly id: string;
  readonly firmId: string;
  readonly name: string;
  readonly email: string;
  readonly title?: string | null;
  readonly notes?: string | null;
  readonly recordStatus: Types.RolodexRecordStatus;
};

export type Rolodex_FirmDetail_FirmInvestorContactsQueryVariables = Types.Exact<{
  firmId: Types.Scalars['UUID']['input'];
}>;

export type Rolodex_FirmDetail_FirmInvestorContactsQuery = {
  readonly __typename?: 'Query';
  readonly firmEmployees?: {
    readonly __typename?: 'FirmEmployeesCollectionSegment';
    readonly totalCount: number;
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'FirmEmployeeFull';
      readonly id: string;
      readonly firmId: string;
      readonly name: string;
      readonly email: string;
      readonly title?: string | null;
      readonly notes?: string | null;
      readonly recordStatus: Types.RolodexRecordStatus;
    }> | null;
  } | null;
};

export type Rolodex_FirmDetail_CreateFirmInvestorContactMutationVariables = Types.Exact<{
  input: Types.CreateFirmEmployeeInput;
}>;

export type Rolodex_FirmDetail_CreateFirmInvestorContactMutation = {
  readonly __typename?: 'Mutation';
  readonly createFirmEmployee?: {
    readonly __typename?: 'CreateFirmEmployeePayload';
    readonly firmEmployee?: {
      readonly __typename?: 'FirmEmployeeFull';
      readonly id: string;
      readonly firmId: string;
      readonly name: string;
      readonly email: string;
      readonly title?: string | null;
      readonly notes?: string | null;
      readonly recordStatus: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutationVariables = Types.Exact<{
  input: Types.UpdateFirmEmployeeInput;
}>;

export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutation = {
  readonly __typename?: 'Mutation';
  readonly updateFirmEmployee?: {
    readonly __typename?: 'UpdateFirmEmployeePayload';
    readonly firmEmployee?: {
      readonly __typename?: 'FirmEmployeeFull';
      readonly id: string;
      readonly firmId: string;
      readonly name: string;
      readonly email: string;
      readonly title?: string | null;
      readonly notes?: string | null;
      readonly recordStatus: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutationVariables = Types.Exact<{
  input: Types.DeleteFirmEmployeeInput;
}>;

export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutation = {
  readonly __typename?: 'Mutation';
  readonly deleteFirmEmployee?: {
    readonly __typename?: 'DeleteFirmEmployeePayload';
    readonly firmEmployee?: {
      readonly __typename?: 'FirmEmployeeFull';
      readonly id: string;
      readonly firmId: string;
      readonly name: string;
      readonly email: string;
      readonly title?: string | null;
      readonly notes?: string | null;
      readonly recordStatus: Types.RolodexRecordStatus;
    } | null;
  } | null;
};

export const Rolodex_FirmDetail_FirmEmployeeFullPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FirmEmployeeFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const Rolodex_FirmDetail_FirmInvestorContactsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmInvestorContacts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'firmEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'firmId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'firmId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'name' },
                          value: { kind: 'EnumValue', value: 'ASC' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FirmEmployeeFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useRolodex_FirmDetail_FirmInvestorContactsQuery__
 *
 * To run a query within a React component, call `useRolodex_FirmDetail_FirmInvestorContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_FirmInvestorContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolodex_FirmDetail_FirmInvestorContactsQuery({
 *   variables: {
 *      firmId: // value for 'firmId'
 *   },
 * });
 */
export function useRolodex_FirmDetail_FirmInvestorContactsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  > &
    (
      | { variables: Rolodex_FirmDetail_FirmInvestorContactsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  >(Rolodex_FirmDetail_FirmInvestorContactsDocument, options);
}
export function useRolodex_FirmDetail_FirmInvestorContactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  >(Rolodex_FirmDetail_FirmInvestorContactsDocument, options);
}
// @ts-ignore
export function useRolodex_FirmDetail_FirmInvestorContactsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_FirmInvestorContactsQuery,
  Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
>;
export function useRolodex_FirmDetail_FirmInvestorContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_FirmInvestorContactsQuery,
        Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  Rolodex_FirmDetail_FirmInvestorContactsQuery | undefined,
  Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
>;
export function useRolodex_FirmDetail_FirmInvestorContactsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        Rolodex_FirmDetail_FirmInvestorContactsQuery,
        Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    Rolodex_FirmDetail_FirmInvestorContactsQuery,
    Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
  >(Rolodex_FirmDetail_FirmInvestorContactsDocument, options);
}
export type Rolodex_FirmDetail_FirmInvestorContactsQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmInvestorContactsQuery
>;
export type Rolodex_FirmDetail_FirmInvestorContactsLazyQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmInvestorContactsLazyQuery
>;
export type Rolodex_FirmDetail_FirmInvestorContactsSuspenseQueryHookResult = ReturnType<
  typeof useRolodex_FirmDetail_FirmInvestorContactsSuspenseQuery
>;
export type Rolodex_FirmDetail_FirmInvestorContactsQueryResult = Apollo.QueryResult<
  Rolodex_FirmDetail_FirmInvestorContactsQuery,
  Rolodex_FirmDetail_FirmInvestorContactsQueryVariables
>;
export const Rolodex_FirmDetail_CreateFirmInvestorContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_CreateFirmInvestorContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFirmEmployeeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firmEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FirmEmployeeFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type Rolodex_FirmDetail_CreateFirmInvestorContactMutationFn = Apollo.MutationFunction<
  Rolodex_FirmDetail_CreateFirmInvestorContactMutation,
  Rolodex_FirmDetail_CreateFirmInvestorContactMutationVariables
>;

/**
 * __useRolodex_FirmDetail_CreateFirmInvestorContactMutation__
 *
 * To run a mutation, you first call `useRolodex_FirmDetail_CreateFirmInvestorContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_CreateFirmInvestorContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rolodexFirmDetailCreateFirmInvestorContactMutation, { data, loading, error }] = useRolodex_FirmDetail_CreateFirmInvestorContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRolodex_FirmDetail_CreateFirmInvestorContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Rolodex_FirmDetail_CreateFirmInvestorContactMutation,
    Rolodex_FirmDetail_CreateFirmInvestorContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Rolodex_FirmDetail_CreateFirmInvestorContactMutation,
    Rolodex_FirmDetail_CreateFirmInvestorContactMutationVariables
  >(Rolodex_FirmDetail_CreateFirmInvestorContactDocument, options);
}
export type Rolodex_FirmDetail_CreateFirmInvestorContactMutationHookResult = ReturnType<
  typeof useRolodex_FirmDetail_CreateFirmInvestorContactMutation
>;
export type Rolodex_FirmDetail_CreateFirmInvestorContactMutationResult =
  Apollo.MutationResult<Rolodex_FirmDetail_CreateFirmInvestorContactMutation>;
export type Rolodex_FirmDetail_CreateFirmInvestorContactMutationOptions =
  Apollo.BaseMutationOptions<
    Rolodex_FirmDetail_CreateFirmInvestorContactMutation,
    Rolodex_FirmDetail_CreateFirmInvestorContactMutationVariables
  >;
export const Rolodex_FirmDetail_UpdateFirmInvestorContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_UpdateFirmInvestorContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateFirmEmployeeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firmEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FirmEmployeeFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutationFn = Apollo.MutationFunction<
  Rolodex_FirmDetail_UpdateFirmInvestorContactMutation,
  Rolodex_FirmDetail_UpdateFirmInvestorContactMutationVariables
>;

/**
 * __useRolodex_FirmDetail_UpdateFirmInvestorContactMutation__
 *
 * To run a mutation, you first call `useRolodex_FirmDetail_UpdateFirmInvestorContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_UpdateFirmInvestorContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rolodexFirmDetailUpdateFirmInvestorContactMutation, { data, loading, error }] = useRolodex_FirmDetail_UpdateFirmInvestorContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRolodex_FirmDetail_UpdateFirmInvestorContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutation,
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutation,
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutationVariables
  >(Rolodex_FirmDetail_UpdateFirmInvestorContactDocument, options);
}
export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutationHookResult = ReturnType<
  typeof useRolodex_FirmDetail_UpdateFirmInvestorContactMutation
>;
export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutationResult =
  Apollo.MutationResult<Rolodex_FirmDetail_UpdateFirmInvestorContactMutation>;
export type Rolodex_FirmDetail_UpdateFirmInvestorContactMutationOptions =
  Apollo.BaseMutationOptions<
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutation,
    Rolodex_FirmDetail_UpdateFirmInvestorContactMutationVariables
  >;
export const Rolodex_FirmDetail_DeleteFirmInvestorContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_DeleteFirmInvestorContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFirmEmployeeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFirmEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firmEmployee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Rolodex_FirmDetail_FirmEmployeeFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FirmEmployeeFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recordStatus' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutationFn = Apollo.MutationFunction<
  Rolodex_FirmDetail_DeleteFirmInvestorContactMutation,
  Rolodex_FirmDetail_DeleteFirmInvestorContactMutationVariables
>;

/**
 * __useRolodex_FirmDetail_DeleteFirmInvestorContactMutation__
 *
 * To run a mutation, you first call `useRolodex_FirmDetail_DeleteFirmInvestorContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRolodex_FirmDetail_DeleteFirmInvestorContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rolodexFirmDetailDeleteFirmInvestorContactMutation, { data, loading, error }] = useRolodex_FirmDetail_DeleteFirmInvestorContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRolodex_FirmDetail_DeleteFirmInvestorContactMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutation,
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutation,
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutationVariables
  >(Rolodex_FirmDetail_DeleteFirmInvestorContactDocument, options);
}
export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutationHookResult = ReturnType<
  typeof useRolodex_FirmDetail_DeleteFirmInvestorContactMutation
>;
export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutationResult =
  Apollo.MutationResult<Rolodex_FirmDetail_DeleteFirmInvestorContactMutation>;
export type Rolodex_FirmDetail_DeleteFirmInvestorContactMutationOptions =
  Apollo.BaseMutationOptions<
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutation,
    Rolodex_FirmDetail_DeleteFirmInvestorContactMutationVariables
  >;
